import { GREEN } from "@/resources/constants/busyReasons";
import { CONFIG } from "@/resources/constants/system";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Store } from "vuex";
import NotificationEvent from "../notifications/notificationEvent";

@Component({})
export default class Loader extends mixins(NotificationEvent) {
  message = "";
  percent = "";
  constructor() {
    super();
  }
  async startLoader($store: Store<any>, cancelTime = 0): Promise<void> {
    //load config default
    const store = !$store ? this.$store : $store;
    const config = store?.getters["UserStore/getConfig"];
    if (!config) {
      this.$store.dispatch("UserStore/setConfigAction", CONFIG);
    }
    const timer = store?.getters["SystemStore/getCallTimer"];
    if (timer != 0) {
      clearTimeout(timer);
    }
    const loader = store?.getters["SystemStore/getLoader"];
    if (!loader) {
      const loader = this.$vs.loading({
        scale: 1.2,
        type: "circles",
        background: "#000",
        color: "#fff",
        text: this.message,
        percent: this.percent,
      });
      await store.dispatch("SystemStore/setLoaderAction", loader);
      if (cancelTime != 0) {
        const timer = setTimeout(() => {
          const loader = store.getters["SystemStore/getLoader"];
          if (loader) {
            loader.close();
            store.dispatch("SystemStore/setLoaderAction", null); 
            store?.dispatch("UserStore/loadPreviousStatusAction", {
              store: store,
              callback: (response) => {
                store?.dispatch("SpaceStore/updateUserInSpace", response.data);
              },
            });
            store.dispatch("SystemStore/setShowCallErrorRetryModalAction", true);
            store.dispatch("SystemStore/setEducationModalAction", false);
            //this.onError("", i18n.t("notifications.errorMessages.connectRoom"), "none"); 
            store.dispatch("SidebarStore/setOpenCall", false);
          }
        }, cancelTime);
        store.dispatch("SystemStore/setCallTimerAction", timer);
      }
    }
  }
  async stopLoader($store?: Store<any>): Promise<void> {
    const store = !$store ? this.$store : $store;
    if (store) {
      const loader = store.getters["SystemStore/getLoader"];
      if (loader) {
        loader.close();
        await store.dispatch("SystemStore/setLoaderAction", null);
      }
    }
  }
  setLoaderText($store?: Store<any>, message?: string): void {
    const store = !$store ? this.$store : $store;
    const loader = store.getters["SystemStore/getLoader"];
    if (loader) {
      loader.text = message;
    }
  }
  setLoaderPercent($store?: Store<any>, percent?: string): void {
    const store = !$store ? this.$store : $store;
    const loader = store.getters["SystemStore/getLoader"];
    if (loader) {
      loader.percent = percent + "%";
    }
  }
}

export enum CANCELLATION_TIME {
  CANCEL_CALL_30 = 30000,
  CANCEL_CALL_40 = 40000,
  CANCEL_CALL_60 = 60000,
}
